import React, { useState } from "react"

import { FormControl, InputLabel, OutlinedInput } from "@material-ui/core"
import SelectCompany from "./SelectCompany"
import SelectApp from "./SelectApp"
import { AppActions } from "../../../store/actions"
import useAppId from "../hooks/useAppId"

const SelectHoc = ({ children, label }) => {
  return (
    <FormControl variant="outlined" style={{ minWidth: 120 }}>
      <InputLabel
        style={{ color: "#000000" }}
        htmlFor={`select-outlined-${label}`}
      >
        {label}
      </InputLabel>
      {children}
    </FormControl>
  )
}

export default ({ user, showLeftNav = true }) => {
  const [company, setCompany] = useState("")
  const appActions = AppActions()
  const app = useAppId()

  const selectCompany = async newCompany => {
    localStorage.setItem("OMNI_SELECTED_COMPANY", newCompany)
    const companyId = user.authorizations.find(
      auth => auth.companyName === newCompany,
    )._id

    localStorage.setItem("OMNI_SELECTED_COMPANY_ID", companyId)
    setCompany(newCompany)
    appActions.getBranches(newCompany)
  }

  const selectApp = async app => {
    localStorage.setItem("OMNI_SELECTED_APP", app)
    appActions.setAppId(app)
  }

  if (!showLeftNav) {
    // resets app selection upon close of left nav
    const auth = user.authorizations.filter(auth => auth.app === app)[0]
    localStorage.setItem("OMNI_SELECTED_COMPANY", auth.companyName)
  }

  const commonProps = label => ({
    style: {
      marginRight: "10px",
      color: "white",
    },
    input: (
      <OutlinedInput
        style={{ color: "inherit" }}
        labelWidth={80}
        margin="dense"
        name={label}
      />
    ),
    inputProps: { id: `select-outlined-${label}` },
  })

  return (
    <>
      <SelectHoc label="Company" >
        <SelectCompany
          user={user}
          onSelect={selectCompany}
          {...commonProps("Company")}
        />
      </SelectHoc>
      &nbsp;
      <SelectHoc label="App">
        <SelectApp
          user={user}
          company={company}
          onSelect={selectApp}
          {...commonProps("App")}
        />
      </SelectHoc>
      &nbsp;
    </>
  )
}
